import React, { useState, useEffect, useRef } from "react";
import VideoContext from "./VideoContext";
import Peer from "simple-peer";
import { message } from "antd";
import { socket } from '../components/ChatBox/Socket/Socket';
import { connect } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import { useLocation } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import ChatServices from "../services/ChatServices";
import Teams from "../components/ChatBox/assests/teams.mp3";

const VideoState = ({ children, currentUser, history }) => {

  const [callAccepted, setCallAccepted] = useState(false);
  const [callEnded, setCallEnded] = useState(false);
  const [stream, setStream] = useState();
  const [chat, setChat] = useState([]);
  const [name, setName] = useState(currentUser?.username);
  const [call, setCall] = useState({});
  const [me, setMe] = useState("");
  const [userName, setUserName] = useState("");
  const [otherUser, setOtherUser] = useState("");
  const [myVdoStatus, setMyVdoStatus] = useState(true);
  const [userVdoStatus, setUserVdoStatus] = useState();
  const [myMicStatus, setMyMicStatus] = useState(true);
  const [userMicStatus, setUserMicStatus] = useState();
  const [msgRcv, setMsgRcv] = useState("");
  const [screenShare, setScreenShare] = useState(false);
  const [openVideoChat, setOpenVideoChat] = useState(false);
  const [callRejected, setCallRejected]= useState(false);
  const currentLocation = history.location;
  const [startStream , setStartStream] = useState(false);

  const [idToCall, setIdToCall] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [audio] = useState(() => { const a = new Audio(); a.preload = "none"; a.src = Teams; return a; });
  const [outgoingAudio] = useState(() => { const a = new Audio(); a.preload = "none"; a.src = Teams; return a; });
  const [calleeDisplayName, setCalleeDisplayName] = useState("");
  const [calleeDisplayImage, setCalleeDisplayImage] = useState("");

  const myVideo = useRef();
  const userVideo = useRef();
  const connectionRef = useRef();
  const screenTrackRef = useRef();

  const openVideoChatTab = () => {
    setOpenVideoChat(true);
  };

  useEffect(() => {
    if (localStorage.getItem("name")) {
      setName(localStorage.getItem("name"));
    }
    socket.on("me", (id) => {
      setMe(id);
      if (currentUser?._id) {
        ChatServices.saveSocketId(currentUser._id, id).catch(() => {});
      }
    });


    socket.on("endCall", () => {
      window.location.reload();
    });

    socket.on("updateUserMedia", ({ type, currentMediaStatus }) => {
      console.log("updateUserMedia",type,currentMediaStatus)
      if (currentMediaStatus !== null || currentMediaStatus.length !== 0) {
        switch (type) {
          case "video":
            setUserVdoStatus(currentMediaStatus);
            break;
          case "mic":
            setUserMicStatus(currentMediaStatus);
            break;
          default:
              setUserMicStatus(currentMediaStatus[0]);
              setUserVdoStatus(currentMediaStatus[1]);
            break;
        }
      }
    });

    socket.on("callUser", ({ from, name: callerName, signal, callerImage, fromUserId }) => {
      setCall({ isReceivingCall: true, from, name: callerName, signal, callerImage, fromUserId });
    });

    socket.on("msgRcv", ({ name, msg: value, sender }) => {
      setMsgRcv({ value, sender });
      setTimeout(() => {
        setMsgRcv({});
      }, 2000);
    });
  }, []);

  const answerCall = async () => {
    setCallAccepted(true);
    setOtherUser(call.from);

    // Log this incoming call to the shared call history in localStorage
    try {
      const prev = JSON.parse(localStorage.getItem("poetCallHistory") || "[]");
      const entry = {
        id: Date.now(),
        ts: new Date().toISOString(),
        contactName: call.name,
        contactId: call.fromUserId || call.from,
        contactImage: call.callerImage || "",
        direction: "incoming",
        status: "incoming",
        callType: "voice",
      };
      localStorage.setItem("poetCallHistory", JSON.stringify([entry, ...prev].slice(0, 200)));
    } catch {}

    setStartStream(true);

    let currentStream = stream;
    if (!currentStream) {
      try {
        currentStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
        setStream(currentStream);
        if (myVideo.current) {
          myVideo.current.srcObject = currentStream;
        }
      } catch (err) {
        try {
          currentStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
          setStream(currentStream);
        } catch (audioErr) {
          console.error("Could not access microphone:", audioErr);
        }
      }
    }

    const peer = new Peer({ initiator: false, trickle: false, stream: currentStream });

    peer.on("signal", (data) => {
      socket.emit("answerCall", {
        signal: data,
        to: call.from,
        userName: name,
        type: "both",
        myMediaStatus: [myMicStatus, myVdoStatus],
      });
    });

    peer.on("stream", (incomingStream) => {
      if (userVideo.current) {
        if ('srcObject' in userVideo.current) {
          userVideo.current.srcObject = incomingStream;
        } else {
          userVideo.current.src = URL.createObjectURL(incomingStream);
        }
      } else {
        console.error("Video element not found.");
      }
    });

    peer.signal(call.signal);

    connectionRef.current = peer;
    openVideoChatTab();
  };

  const callUser = async (id, displayName = "", displayImage = "") => {
    setCalleeDisplayName(displayName);
    setCalleeDisplayImage(displayImage);
    setOtherUser(id);
    // Show the call overlay immediately so the user always sees the hang-up button
    setOpenVideoChat(true);
    outgoingAudio.loop = true;
    outgoingAudio.play().catch(() => {});

    let currentStream = stream;
    if (!currentStream) {
      try {
        currentStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
        setStream(currentStream);
        if (myVideo.current) {
          myVideo.current.srcObject = currentStream;
        }
      } catch (err) {
        try {
          currentStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
          setStream(currentStream);
        } catch (audioErr) {
          console.error("Could not access microphone:", audioErr);
          // Don't return — overlay is already shown so user can cancel
        }
      }
    }

    const peer = new Peer({ initiator: true, trickle: false, stream: currentStream });

    peer.on("signal", (data) => {
      socket.emit("callUser", {
        userToCall: id,
        signalData: data,
        from: me,
        name: displayName || name,
        callerImage: displayImage,
        fromUserId: currentUser?._id,
      });
    });

    peer.on("stream", (incomingStream) => {
      if (userVideo.current) {
        if ('srcObject' in userVideo.current) {
          userVideo.current.srcObject = incomingStream;
        } else {
          userVideo.current.src = URL.createObjectURL(incomingStream);
        }
      } else {
        console.error("Video element not found.");
      }
    });

    socket.on("callAccepted", ({ signal, userName }) => {
      outgoingAudio.pause();
      outgoingAudio.currentTime = 0;
      setCallAccepted(true);
      setStartStream(true, 'Stream on other Side');
      setUserName(userName);
      peer.signal(signal);
      socket.emit("updateMyMedia", {
        type: "both",
        currentMediaStatus: [myMicStatus, myVdoStatus],
      });
    });

    connectionRef.current = peer;
  };


  const updateVideo = () => {
    setMyVdoStatus((currentStatus) => {
      socket.emit("updateMyMedia", {
        type: "video",
        currentMediaStatus: !currentStatus,
        to: otherUser,
      });
      stream.getVideoTracks()[0].enabled = !currentStatus;
      return !currentStatus;
    });
  };

  const updateMic = () => {
    setMyMicStatus((currentStatus) => {
      console.log(currentStatus);
      socket.emit("updateMyMedia", {
        type: "mic",
        currentMediaStatus:!currentStatus,
        to: otherUser,
      });
      console.log("stream_before",stream,stream.getAudioTracks()[0].enabled)

      stream.getAudioTracks()[0].enabled = !currentStatus;
      // stream.getAudioTracks()[0].muted = !(stream.getAudioTracks()[0].muted);
      // stream.getAudioTracks().forEach(track => track.enabled = !track.enabled);

      console.log("stream_after",stream,!stream.getAudioTracks()[0].enabled)

      // peer.removeTrack(stream.getAudioTracks()[0], stream);
     
    //   stream.getTracks().forEach((track) => {
    //     if (track.kind === "mic") {
    //         track.enabled = !track.enabled;
    //     }
    // });
      return !currentStatus;
    });
  };


  
    //SCREEN SHARING 
    // const handleScreenSharing = () => {

    //   if(!myVdoStatus){
    //     message.error("Turn on your video to share the content", 2);
    //     return;
    //   }
    
    //   if (!screenShare) {
    //     navigator.mediaDevices
    //       .getDisplayMedia({ cursor: true })
    //       .then((currentStream) => {
    //         const screenTrack = currentStream.getTracks()[0];

  
    //           // replaceTrack (oldTrack, newTrack, oldStream);
    //           connectionRef.current.replaceTrack(
    //             connectionRef.current.streams[0]
    //               .getTracks()
    //               .find((track) => track.kind === 'video'),
    //             screenTrack,
    //             stream
    //           );
  
    //         // Listen click end
    //         screenTrack.onended = () => {
    //           connectionRef.current.replaceTrack(
    //               screenTrack,
    //               connectionRef.current.streams[0]
    //                 .getTracks()
    //                 .find((track) => track.kind === 'video'),
    //               stream
    //             );

    //           myVideo.current.srcObject = stream;
    //           setScreenShare(false);
    //         };
  
    //         myVideo.current.srcObject = currentStream;
    //         screenTrackRef.current = screenTrack;
    //         setScreenShare(true);
    //       }).catch((error) => {
    //         console.log("No stream for sharing")
    //       });
    //   } else {
    //     screenTrackRef.current.onended();
    //   }
    // };

     //full screen
     
     
     const fullScreen = (e) => {
      const elem = e.target;
  
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    };
    
  const leaveCall = () => {
    setCallEnded(true);
    const peer = new Peer({ initiator: false, trickle: false, stream });
    peer.removeAllListeners();
    peer._destroy();
    connectionRef.current.destroy();
    socket.emit("endCall", { id: otherUser });
    setOpenVideoChat(false);
  };

  const leaveCall1 = () => {
    outgoingAudio.pause();
    outgoingAudio.currentTime = 0;
    audio.pause();
    audio.currentTime = 0;
    socket.emit("endCall", { id: otherUser });
    setOpenVideoChat(false);
  };


  const sendMsg = (value) => {
    socket.emit("msgUser", { name, to: otherUser, msg: value, sender: name });
    let msg = {};
    msg.msg = value;
    msg.type = "sent";
    msg.timestamp = Date.now();
    msg.sender = name;
    setChat([...chat, msg]);
  };

  return (
    <VideoContext.Provider
      value={{
        call,
        callAccepted,
        userVideo,
        stream,
        name,
        myVideo,
        setName,
        callEnded,
        me,
        callUser,
        leaveCall,
        answerCall,
        sendMsg,
        msgRcv,
        chat,
        setChat,
        setMsgRcv,
        setOtherUser,
        leaveCall1,
        userName,
        myVdoStatus,
        setMyVdoStatus,
        userVdoStatus,
        setUserVdoStatus,
        updateVideo,
        myMicStatus,
        userMicStatus,
        updateMic,
        screenShare,
        fullScreen,
        isModalVisible,
        setIsModalVisible,
        audio,
        idToCall, 
        setIdToCall,
        setStream,
        setCallAccepted,
        openVideoChat,
        setOpenVideoChat,
        callRejected, setCallRejected,
        startStream, setStartStream,
        calleeDisplayName,
        calleeDisplayImage,
        outgoingAudio
      }}
    >
      {children}
    </VideoContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  features: state.features.features,
});
const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VideoState));